import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { FiEye, FiEyeOff } from "react-icons/fi";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

/* =======================
   DOMAIN EMAIL YANG DIIZINKAN
======================= */
const allowedDomains = [
  "gmail.com",
  "googlemail.com",

  "icloud.com",
  "me.com",
  "mac.com",

  "yahoo.com",
  "yahoo.co.id",

  "outlook.com",
  "hotmail.com",
  "live.com",

  "email.com",
  "proton.me",
  "protonmail.com",
  "zoho.com",
  "mail.com",
  "gmx.com",
  "fastmail.com",

  "yandex.com",
  "yandex.ru",
];

/* =======================
   CEK EMAIL DOMAIN
======================= */
const isAllowedEmail = (email) => {
  if (!email.includes("@")) return false;
  const domain = email.toLowerCase().split("@")[1];
  return allowedDomains.includes(domain);
};

export default function DaftarAkun() {
  const [nama, setNama] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    /* =======================
       VALIDASI EMAIL DOMAIN
    ======================= */
    if (!isAllowedEmail(email)) {
      Swal.fire({
        icon: "warning",
        title: "Email tidak didukung",
        text: "Gunakan Gmail, Yahoo, iCloud, Outlook, Email.com, atau penyedia email umum lainnya.",
      });
      return;
    }

    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        nama,
        email,
        role: "siswa",
        createdAt: new Date().toISOString(),
      });

      await Swal.fire({
        icon: "success",
        title: "Akun berhasil dibuat!",
        text: "Silakan login untuk masuk ke aplikasi.",
        showConfirmButton: false,
        timer: 2500,
      });

      navigate("/login");
    } catch (error) {
      console.error("Error daftar:", error);

      Swal.fire({
        icon: "error",
        title: "Gagal membuat akun!",
        text: error.message,
      });
    }

    setLoading(false);
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "400px" }}>
      <h3 className="text-center mb-4 fw-bold text-success">
        Daftar Akun Siswa
      </h3>

      <form onSubmit={handleRegister}>
        <div className="mb-3">
          <label className="form-label">Nama Lengkap</label>
          <input
            type="text"
            className="form-control"
            value={nama}
            onChange={(e) => setNama(e.target.value)}
            required
            placeholder="Masukkan nama lengkap"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="contoh@gmail.com"
          />
          <small className="text-muted">
            * Hanya email umum (Gmail, Yahoo, iCloud, Outlook, dll)
          </small>
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Minimal 6 karakter"
            />
            <span
              className="input-group-text"
              style={{ cursor: "pointer" }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-success w-100"
          disabled={loading}
        >
          {loading ? "Mendaftarkan..." : "Daftar Akun"}
        </button>
      </form>

      <p className="text-center mt-3">
        Sudah punya akun?{" "}
        <Link to="/login" className="text-decoration-none fw-semibold">
          Login di sini
        </Link>
      </p>
    </div>
  );
}
